import { useState, useEffect } from 'react';
import Button from "@material-ui/core/Button";
import { makeStyles, ButtonGroup } from "@material-ui/core";
import { DataGrid } from "@material-ui/data-grid";
import { getAdminRoles, deleteRole, getRole, changeRoleStatus } from "../../../../store/actions/admin/role";
import { useSelector, useDispatch } from 'react-redux';
import moment from "moment";
import Switch from '@material-ui/core/Switch';
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import Backdrop from "@material-ui/core/Backdrop/Backdrop";
import RoleModel from './roleModel';
import ViewRole from './viewRole';

const useStyles = makeStyles((theme) => ({
	root: {
		marginTop: theme.spacing(3),
	}
}));

export default function List() {
	const classes = useStyles();
	const dispatch = useDispatch();
	const [newrows, setNewrows] = useState([]);
	const [showModal, setShowModal] = useState(false);
	const [showViewModal, setShowViewModal] = useState(false);
	const { roles, loading } = useSelector((state: any) => state.adminRole);
	const apolloClient = useSelector((state: any) => state.apolloClient);
	const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : ""

	const deleteRoleAction = (value: any) => {
		const request = {
			roleid: value.row.id,
			schema: loginUserData.customer_name
		}
		dispatch(deleteRole(apolloClient.client, request));
	};

	//method call click on view button
	const getRoleAction = (value: any, action: string) => {

		if (action === 'view') {
			setShowViewModal(true);
		} else {
			setShowModal(true);
		}
		const request = {
			roleid: value.row.id,
			schema: loginUserData.customer_name
		};
		dispatch(getRole(apolloClient.client, request));
	}

	//Close model
	const closeModal = () => {
		setShowViewModal(false);
		setShowModal(false);
	};

	// Call method on change switch
	const statusAction = (value: any) => {
		const request = {
			roleid: value.row.id,
			active: !value.row.active,
			schema: loginUserData.customer_name
		}
		dispatch(changeRoleStatus(apolloClient.client, request));
	}

	const columns: any[] = [
		{
			field: "role_name", headerName: "Name", width: 130, renderCell: (params: any) => {
				return params.row.role_name ? params.row.role_name : "-"
			}
		},
		{
			field: "role_alias", headerName: "Alias", width: 130, renderCell: (params: any) => {
				return params.row.role_alias ? params.row.role_alias : "-"
			}
		},
		{
			field: "role_description", headerName: "Description", width: 150, renderCell: (params: any) => {
				return params.row.role_description ? params.row.role_description : "-"
			}
		},
		{ field: "created_at", headerName: "Created Date", width: 180 },
		{ field: "updated_at", headerName: "Last Edited", width: 180 },
		{
			field: "active", headerName: "Active", width: 150, sortable: false, renderCell: function RoleActive(params: any){
				return <div>
					<Switch
						value={params.row.active ? true : false}
						checked={params.row.active ? true : false}
						className="access-page-switch"
						onClick={
							() => statusAction(params)
						}
						color="primary"
						name="home_page"
						inputProps={{ 'aria-label': 'primary checkbox' }}
					/>
				</div>
			}
		},
		{
			field: "id", headerName: "Action", width: 200, sortable: false, renderCell: function ActionRole (params: any){
				return <ButtonGroup color="primary" size="large" aria-label="outlined primary button group">
					<Button
						type="button"
						title="View"
						onClick={
							() => getRoleAction(params, 'view')
						}>
						<i className="icon-eye" />
					</Button>
					<Button
						type="button"
						title="Update"
						onClick={
							() => getRoleAction(params, 'edit')
						}>
						<i className="icon-pencil" />
					</Button>
					<Button
						type="button"
						title="Delete"
						onClick={
							() => deleteRoleAction(params)
						}>
						<i className="icon-trash" />
					</Button>
				</ButtonGroup>
			}
		},
	];

	useEffect(() => {
		const roleFiled: any = [];
		roles && roles.map((val: any) => {
			roleFiled.push(
				{
					id: val.role_id,
					role_name: val.role_name,
					active: val.active,
					role_alias: val.role_alias,
					role_description: val.role_description,
					created_at: val.created_at ? moment(Number(val.created_at)*1000).format("MM/DD/YYYY hh:mm ") : "",
					updated_at: val.updated_at ? moment(Number(val.updated_at)*1000).format("MM/DD/YYYY hh:mm ") : "",
				}
			)
		})
		setNewrows(roleFiled)
	}, [roles]);

	useEffect(() => {
		const request = { customer_name: loginUserData.customer_name };
		dispatch(getAdminRoles(apolloClient.client, request));
	}, [apolloClient.client, dispatch, loginUserData.user_id]);

	return (
		<>
			<div className={classes.root}>
				<div className="card">
					<div style={{ height: `calc(100vh - 250px)`, width: "100%" }}>
						<DataGrid rows={newrows} columns={columns} pageSize={10} density="standard" />
					</div>
				</div>
				<div className="loader">
					<Backdrop open={loading} >
						<CircularProgress color="inherit" />
					</Backdrop>
				</div>
				{showModal && (<RoleModel open={showModal} onClose={closeModal} from="edit" />)}
				{showViewModal && (<ViewRole open={showViewModal} onClose={closeModal} />)}
			</div>
		</>
	);
}
